import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';

const TextAlignHeaderType = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};

class SimpleNavigation extends Component {
  static propTypes = {
    textAlignment: PropTypes.string,
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    enableHideOnSmall: PropTypes.bool,
    menuItemHoverStyle: PropTypes.object,
    menu: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        href: PropTypes.string.isRequired,
        target: PropTypes.string
      }).isRequired
    ).isRequired
  }

  static defaultProps = {
    textAlignment: TextAlignHeaderType.LEFT,
    backgroundColor: '#FFF',
    textColor: '#000',
    enableHideOnSmall: true,
    menuItemHoverStyle: {}
  }

  state = {
    hover: false
  }

  render() {
    const {
      textAlignment,
      backgroundColor,
      textColor,
      menuItemHoverStyle,
      menu: menuItems,
      enableHideOnSmall
    } = this.props;

    const componentClassName = classNames('SimpleNavigation', {'hidden-xs': enableHideOnSmall});

    return (
      <div className={componentClassName} style={{backgroundColor}}>
        <div className="container">
          <div className="navbar-header">
            <button className="navbar-toggle collapsed" data-toggle="collapse" data-target="#simple-navbar" aria-expanded="false" aria-controls="navbar">
              <svg x="0px" y="0px" width="24px" height="24px" viewBox="0 0 36 36" xmlSpace="preserve">
                <line x1="4" y1="18" x2="32" y2="18" />
                <line x1="4" y1="6" x2="32" y2="6" />
                <line x1="4" y1="30" x2="32" y2="30" />
              </svg>
            </button>
          </div>
          <nav className="navbar navbar-default">
            <div id="simple-navbar" className="navbar-collapse collapse" aria-expanded="false">
              <ul className="nav navbar-nav" style={{float: textAlignment !== TextAlignHeaderType.CENTER ? textAlignment : null}}>
                {menuItems.map((item, index) => {
                    return (
                      <MenuItem key={index} text={item.text} href={item.href} target={item.target} textColor={textColor} hoverStyle={menuItemHoverStyle} />
                    );
                })}
              </ul>
            </div>
          </nav>
        </div>
      </div>
    );
  }
}

class MenuItem extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    textColor: PropTypes.string.isRequired,
    target: PropTypes.string,
    hoverStyle: PropTypes.object
  }

  static defaultProps = {
    hoverStyle: {},
    target: '_self'
  }

  state = {
    hover: false
  }

  render() {
    const {
      href,
      text,
      textColor,
      target,
      hoverStyle
    } = this.props;

    const {
      hover
    } = this.state;

    let style = {
      color: textColor
    };

    if (hover) {
      style = _.assign(style, hoverStyle);
    }

    return (
      <li>
        <a onMouseEnter={() => this.setState({ hover: true })}
           onMouseLeave={() => this.setState({ hover: false })}
           href={href}
           target={target}
           style={style}>
           {text}
         </a>
      </li>
    );
  }
}

export default SimpleNavigation;



// WEBPACK FOOTER //
// ./app/components/core/SimpleNavigation.js